var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "windows",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16.962,
    viewBox: "0 0 17 16.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10722",
    "data-name": "Group 10722",
    transform: "translate(7.621 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10721",
    "data-name": "Group 10721"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70851",
    "data-name": "Path 70851",
    d: "M216.069,8.638a.819.819,0,0,0,.8-.8V1.194a.666.666,0,0,0-.783-.666l-7.855,1.149a.905.905,0,0,0-.741.891V7.841a.741.741,0,0,0,.708.8Z",
    transform: "translate(-207.493 -0.52)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10724",
    "data-name": "Group 10724",
    transform: "translate(0 1.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10723",
    "data-name": "Group 10723"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70852",
    "data-name": "Path 70852",
    d: "M7.035,41.253a.716.716,0,0,0-.844-.666l-5.363.772A.988.988,0,0,0,0,42.25v4.177a.836.836,0,0,0,.822.8H6.108a.937.937,0,0,0,.926-.8V41.253Z",
    transform: "translate(0 -40.578)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10726",
    "data-name": "Group 10726",
    transform: "translate(0 8.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10725",
    "data-name": "Group 10725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70853",
    "data-name": "Path 70853",
    d: "M.822,237.516a.872.872,0,0,0-.822.838V242.6a.953.953,0,0,0,.791.893l5.388.784a.726.726,0,0,0,.855-.666v-5.258a.973.973,0,0,0-.926-.838Z",
    transform: "translate(0 -237.516)",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10728",
    "data-name": "Group 10728",
    transform: "translate(7.621 8.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10727",
    "data-name": "Group 10727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70854",
    "data-name": "Path 70854",
    d: "M207.492,243.711a.9.9,0,0,0,.735.891l7.879,1.163a.65.65,0,0,0,.765-.664v-6.747a.855.855,0,0,0-.8-.838H208.2a.778.778,0,0,0-.708.838Z",
    transform: "translate(-207.492 -237.516)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.eed0e8e19890ba83ff219388beb40722.svg";
export { ForwardRef as ReactComponent };